export { default as Home } from './Home/Index.vue'
export { default as HomePreview } from './HomePreview'
export { default as OnDemand } from './OnDemand'
export { default as Schedule } from './Schedule'
export { default as MyList } from './MyList'
export { default as Search } from './Search'
export { default as FreeExperience } from './FreeExperience'
export { default as Options } from './Options'
export { default as Training } from './Training/index.vue'
